import { Module, VuexModule, Mutation } from 'vuex-module-decorators'
import { ShippingMethodQuery } from '~/graphql/types'

@Module({
  name: 'shipping-method',
  stateFactory: true,
  namespaced: true,
})
export default class ShippingMethod extends VuexModule {
  fetchStarted = false
  loading = true
  items: ShippingMethodQuery['shipping_method'] = []

  @Mutation
  setFetchStarted(fetchStarted) {
    this.fetchStarted = fetchStarted
  }

  @Mutation
  setLoading(loading) {
    this.loading = loading
  }

  @Mutation
  setItems(items) {
    this.items = items
  }
}
